export default __webpack_public_path__ + "static/media/macbook.0385789f.jpg";